import type { NavigationGuardWithThis } from "vue-router";

const upgradeWebBrowserRouteName = "error-upgrade-web-browser";

export function createBrowserUpgradeTerminalGuard(): NavigationGuardWithThis<undefined> {
  return (to, from) => !(from.name === upgradeWebBrowserRouteName && to.name !== upgradeWebBrowserRouteName);
}
